import * as React from "react";
import { useTranslation } from "react-i18next";
import { EmptyList } from "security-app/components/common";
import { GLCheckbox, RowTitleButton } from "common/components";
import { usePagination, useSelectedRows, useSelectedRowsDispatch } from "common/contexts";
function ListRows({ investigations }) {
  const { t } = useTranslation("enterprise_security_investigations");
  const localPagination = usePagination();
  const selectedInvestigations = useSelectedRows();
  const selectedInvestigationsDispatch = useSelectedRowsDispatch();
  const onChange = (investigation) => (e) => {
    if (e.target.checked) {
      selectedInvestigationsDispatch({ type: "add", payload: [investigation] });
    } else {
      selectedInvestigationsDispatch({ type: "remove", payload: [investigation] });
    }
  };
  const onNameClick = (investigation) => () => {
    if (selectedInvestigations.find((sInv) => sInv.id === investigation.id)) {
      selectedInvestigationsDispatch({ type: "remove", payload: [investigation] });
    } else {
      selectedInvestigationsDispatch({ type: "add", payload: [investigation] });
    }
  };
  const isSelected = (investigation) => !!selectedInvestigations.find((sInv) => investigation.id === sInv.id);
  return investigations.length < 1 ? /* @__PURE__ */ React.createElement(
    EmptyList,
    {
      query: localPagination.query,
      filters: localPagination.filters,
      noSearchResultText: t("evidence_list.no_search_result"),
      noEntitiesExist: t("evidence_list.no_entities"),
      colSpan: 3
    }
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null, investigations.map((investigation) => /* @__PURE__ */ React.createElement("tr", { key: `investigation-row-${investigation.id}`, "data-testid": "open-investigation-row" }, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
    GLCheckbox,
    {
      checked: isSelected(investigation),
      onChange: onChange(investigation),
      "data-testid": "investigation-checkbox"
    }
  )), /* @__PURE__ */ React.createElement("td", { "data-testid": "investigation-name", role: "checkbox" }, /* @__PURE__ */ React.createElement(RowTitleButton, { onClick: onNameClick(investigation) }, investigation.name)), /* @__PURE__ */ React.createElement("td", null, investigation.status))));
}
export default ListRows;
